import { CODE_BEIKE_1, CODE_BEIKE_2, CODE_BEIKE_3 } from "@/utils/constant";

const mapCodeToName = {
  [CODE_BEIKE_1]: CODE_BEIKE_1,
  [CODE_BEIKE_2]: CODE_BEIKE_2,
  [CODE_BEIKE_3]: CODE_BEIKE_3,
};

const modulesFiles = require.context("../assets/images", true, /\.png/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value;
  return modules;
}, {});

export const getImagePath = (code, module) => {
  return modules[(mapCodeToName[code] || code) + "_" + module];
};
